import { createRouter, createWebHistory } from 'vue-router';

import melcoRoutes from './integrations/factory/routes/melco';
import { statelessRoutes as accountRoutes } from './pages/account';
import authRoutes from './pages/auth';
import { statelessRoutes as errorRoutes } from './pages/error';
import loading from './pages/loading';

export const router = createRouter({
  history: createWebHistory(),
  routes: [loading, ...authRoutes, ...accountRoutes, ...errorRoutes, ...melcoRoutes],
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
        top: 72,
      };
    }

    return;
  },
});
